import { lazy } from '@deqo/foundation';
import { component, Component, ComponentPolicy, property } from '../../../concepts/objects';

export type ItemPrototype = {
    id: string,
    text: string,
    color: string,
};

export const ItemPrototype = (id: string, text: string, color: string): ItemPrototype => ({ id, text, color });

const voterItemDef = {
    name: 'VoterItem',
};

@component(voterItemDef)
export class VoterItem extends Component {

    @property({ type: 'string' })
    public color: string;

    @property({ type: 'string' })
    public text: string;

    @lazy()
    protected get policy(): ComponentPolicy {
        return ComponentPolicy.noChildren('VoterItem');
    }
}
